export default {
  state: {
    ambassador: null,
    isSchoolAmbassador: false,
    isEnterFromAmbassador: false
  },
  mutations: {
    // 设置大使信息
    setSchoolAmbassador(state, val) {
      state.ambassador = val;
    },

    setIsSchoolAmbassador(state, val) {
      state.isSchoolAmbassador = val;
    },

    setIsEnterFromAmbassador(state, val) {
      state.isEnterFromAmbassador = val;
    }
  },
  actions: {},
  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/schoolAmbassador/index.js